import crudActions from '@/store/crudActions'
import axios from '@/libs/axios'

const endpoint = 'main-total-quote'
const Actions = crudActions(endpoint)

const changeQuoteStatus = (ctx, data) => new Promise((resolve, reject) => {
  axios.post(`${endpoint}/change_quote_status/`, data.body, { params: { id: data.quoteDistributionId } })
    .then(response => {
      resolve(response)
    })
    .catch(error => {
      console.log(error)
      reject(error)
    })
})

const financeAcceptedLetterQuote = ({ commit }, queryParams) => new Promise((resolve, reject) => {
  axios.get(`${endpoint}/finance_accepted_letter_quote/`, { params: queryParams })
    .then(response => {
      commit('FINANCE_ACCEPTED_LETTER_QUOTE', response.data)
      resolve(response)
    })
    .catch(error => {
      console.log(error)
      reject(error)
    })
})
const createQuoteDistribution = (ctx, quoteDistribution) => new Promise((resolve, reject) => {
  const formData = new FormData()
  formData.append('about', quoteDistribution.about)
  formData.append('period', quoteDistribution.period)
  formData.append('total_quote_type', quoteDistribution.total_quote_type)
  formData.append('to_org', quoteDistribution.to_org)
  formData.append('total_quote_items', JSON.stringify(quoteDistribution.total_quote_items))
  if (quoteDistribution.file instanceof File) formData.append('file', quoteDistribution.file)
  const params = {}
  if (quoteDistribution?.smsCode) {
    params.code = quoteDistribution.smsCode
  }
  axios.post(`${endpoint}/`, formData, { params })
    .then(response => {
      resolve(response)
    })
    .catch(error => {
      console.log(error)
      reject(error)
    })
})
const getOtmItmAcceptedLetterQuotes = ({ commit }, queryParams) => new Promise((resolve, reject) => {
  axios.get(`${endpoint}/get_otm_itm_accepted_letter_quotes/`, { params: queryParams })
    .then(response => {
      commit('OTM_ITM_ACCEPTED_LETTER_QUOTES', response.data)
      resolve(response)
    })
    .catch(error => {
      console.log(error)
      reject(error)
    })
})
const getBalance = ({ commit }, queryParams) => new Promise((resolve, reject) => {
  axios.get(`${endpoint}/balance_base_quote_org/`, { params: queryParams })
    .then(response => {
      commit('OTM_BALANCE', response.data.ans)
      resolve(response)
    })
    .catch(error => {
      console.log(error)
      reject(error)
    })
})
const updateItem = (ctx, item) => axios.post(`${endpoint}/main_quote_item_create/`, item)
const send = (ctx, data) => {
  const params = {}
  if (data.has('smsCode')) {
    params.code = data.get('smsCode')
    data.delete('smsCode')
  }
  return axios.patch(`${endpoint}/change_total_quote_status/`, data, { params })
}
export default {
  ...Actions,
  financeAcceptedLetterQuote,
  createQuoteDistribution,
  getOtmItmAcceptedLetterQuotes,
  updateItem,
  send,
  getBalance,
  changeQuoteStatus,
}
